module.exports = __webpack_public_path__ + "img/4.f17160f2.png";